module.exports = __webpack_public_path__ + "static/img/carousel_1@2x.3404387.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel_1@2x.png
// module id = mYqU
// module chunks = 1